import { LANG } from "@/common/constant";
import isEqual from "lodash/isEqual";
import LogRocket from "logrocket";
// export function compareWithKeys(objectA: any, objectB: any, keys: string[]): boolean {
//   let isChange = false;
//   keys.every(key => {
//     if (objectA[key] === objectB[key]) {
//       return true;
//     }
//     isChange = true;
//     return false;
//   })
//
//   return isChange;
// }

export function replaceEmptyWithNullForArray(items = []) {
  items = items.map(function(object) {
    if (typeof object === "object") {
      if (Array.isArray(object)) {
        replaceEmptyWithNullForArray(object);
      } else {
        replaceEmptyWithNullForObject(object);
      }
    } else {
      if (object === "") {
        object = null;
      }
    }

    return object;
  });
  return items;
}

export function replaceEmptyWithNullForObject(items = {}) {
  for (const key in items) {
    if (typeof items[key] === "object") {
      if (Array.isArray(items[key])) {
        replaceEmptyWithNullForArray(items[key]);
      } else {
        replaceEmptyWithNullForObject(items[key]);
      }
    } else {
      if (items[key] === "") {
        items[key] = null;
      }
    }
  }
  return items;
}

export function compareWithKeys(
  objectA: any,
  objectB: any,
  keys: string[],
  emptyEqualNull = false,
): boolean {
  let isChange = false;
  if (emptyEqualNull) {
    objectA = replaceEmptyWithNullForObject(objectA);
    objectB = replaceEmptyWithNullForObject(objectB);
  }
  keys.every((key) => {
    isChange = false;
    if (objectA[key] && typeof objectA[key] === "object") {
      isChange = isEqual(objectA[key], objectB[key]);
      return isChange;
    } else if (objectA[key] === objectB[key]) {
      isChange = true;
    }
    return isChange;
  });

  return isChange;
}
export function formatPostalCode(postalCode: string): string {
  return postalCode.includes("-")
    ? postalCode
    : postalCode.replace(/(\d{3})(\d{4})/g, "$1-$2");
}

// copy input type from core system
export const InputTypes = {
  Text: "",
  Day: "",
  TELFAX: "",
  NumCode: "", // 郵便番号
  Number: "",
} as const;
export type InputType = keyof typeof InputTypes;

export class InputPolicy {
  public static check(input: string, type: InputType): string {
    if (input) {
      switch (type) {
        case "Text":
          return this.forText(input);
        case "TELFAX":
          return this.forTelFax(input);
        case "Day":
          return this.forDay(input);
        case "NumCode":
          return this.forNumCode(input);
        case "Number":
          return this.forNumCode(input);
      }
    }
    return input;
  }

  public static forText(input: string): string {
    return input.replace(/[\']/g, "");
  }

  public static forTelFax(input: string): string {
    return input.replace(/[^0-9\-\+\(\)]/g, "");
  }

  public static forDay(input: string): string {
    return input.replace(/[^0-9\-]/g, "");
  }

  public static forNumCode(input: string): string {
    return input.replace(/[^0-9\-]/g, "");
  }
  public static forNumber(input: string): string {
    return input.replace(/[^0-9]/g, "");
  }
}

export const CountLengthAsSjis = (str: string): number => {
  let r = 0;
  for (let i = 0; i < str.length; i++) {
    const c = str.charCodeAt(i);
    // Shift_JIS: 0x0 ～ 0x80, 0xa0 , 0xa1 ～ 0xdf , 0xfd ～ 0xff
    // Unicode : 0x0 ～ 0x80, 0xf8f0, 0xff61 ～ 0xff9f, 0xf8f1 ～ 0xf8f3
    if (
      (c >= 0x0 && c < 0x81) ||
      c == 0xf8f0 ||
      (c >= 0xff61 && c < 0xffa0) ||
      (c >= 0xf8f1 && c < 0xf8f4)
    ) {
      r += 1;
    } else {
      r += 2;
    }
  }
  return r;
};

export const MaxBiteFilter = (str: string, maxBite: number): string => {
  let r = 0;
  let result = "";
  let current = 0;
  if (!str) {
    return result;
  }
  for (let i = 0; i < str.length; i++) {
    const c = str.charCodeAt(i);
    // Shift_JIS: 0x0 ～ 0x80, 0xa0 , 0xa1 ～ 0xdf , 0xfd ～ 0xff
    // Unicode : 0x0 ～ 0x80, 0xf8f0, 0xff61 ～ 0xff9f, 0xf8f1 ～ 0xf8f3
    if (
      (c >= 0x0 && c < 0x81) ||
      c == 0xf8f0 ||
      (c >= 0xff61 && c < 0xffa0) ||
      (c >= 0xf8f1 && c < 0xf8f4)
    ) {
      current = 1;
    } else {
      current = 2;
    }

    if (maxBite < r + current) {
      return result;
    } else {
      result += str[i];
      r += current;
    }
  }

  return result;
};

export function makeid(length = 30) {
  let result = "";
  const characters =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  const charactersLength = characters.length;
  for (let i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
}

export function formatImageUrl(
  fileName,
  size = "400x400",
  type = "cover",
  background = "ffffff",
) {
  let slash = "/";
  if (process.env.VUE_APP_IMAGE_URL.substr(-1) === "/") {
    slash = "";
  }
  if (fileName) {
    return `${process.env.VUE_APP_IMAGE_URL}${slash}${size}/${type}/${background}?u=${fileName}`;
  }
  return `${process.env.VUE_APP_IMAGE_URL}${slash}${size}/${type}/${background}?u=noimage.png`;
}

export function formatVideoUrl(fileName: string) {
  let slash = "/";
  const paths = fileName.split("/");
  let realName = paths[paths.length - 1];
  // /?path=output/mp4-test01/mp4-test01.m3u8
  if (process.env.VUE_APP_VIDEO_URL.substr(-1) === "/") {
    slash = "";
  }
  const fileExtension = fileName.split(".").pop();
  fileName = fileName.replace(/\.mp4/i, "").replace(/\.mov/i, "");
  realName = realName.replace(/\.mp4/i, "").replace(/\.mov/i, "");

  return fileName
    ? `${process.env.VUE_APP_VIDEO_URL}${slash}output/${fileName}.${fileExtension}/${realName}.m3u8`
    : "";
}

export function formatFileUrl(fileName: string) {
  let slash = "/";
  // /?path=output/mp4-test01/mp4-test01.m3u8
  if (process.env.VUE_APP_FILE_URL.substr(-1) === "/") {
    slash = "";
  }

  return fileName ? `${process.env.VUE_APP_FILE_URL}${slash}${fileName}` : "";
}

export function getShippingUrl(shippingNumber) {
  return `http://k2k.sagawa-exp.co.jp/p/web/okurijosearch.do?okurijoNo=${shippingNumber}`;
}

export function getShippingYamatoUrl(shippingNumber) {
  return (
    "https://member.kms.kuronekoyamato.co.jp/parcel/detail?pno=" +
    shippingNumber
  );
}

export function getYoutubeUrl(movieId) {
  let slash = "/";
  if (process.env.VUE_APP_YOUTUBE_URL.substr(-1) === "/") {
    slash = "";
  }
  return `${process.env.VUE_APP_YOUTUBE_URL}${slash}${movieId}`;
}

export function formatQueryToArray(query, name) {
  if (query[name]) {
    query[name] = Array.isArray(query[name]) ? query[name] : [query[name]];
  }
  return query;
}

export function isImageMime(mimeType) {
  return mimeType.startsWith("image/");
}

export function getAttributeByLangSnakeCase(object, attributeName, lang) {
  if (object === null) {
    return null;
  }
  if (lang === LANG.EN) {
    return Array.isArray(object)
      ? object[attributeName + "_en"] || object[attributeName]
      : object[attributeName + "_en"] || object[attributeName];
  } else if (lang === LANG.CN) {
    return Array.isArray(object)
      ? object[attributeName + "_cn"] ||
          object[attributeName + "_en"] ||
          object[attributeName]
      : object[attributeName + "_cn"] ||
          object[attributeName + "_en"] ||
          object[attributeName];
  } else {
    return Array.isArray(object)
      ? object[attributeName]
      : object[attributeName];
  }
}

export function getAttributeByLangCamelCase(object, attributeName, lang) {
  if (object === null) {
    return null;
  }
  if (lang === LANG.EN) {
    return Array.isArray(object)
      ? object[attributeName + "En"] || object[attributeName]
      : object[attributeName + "En"] || object[attributeName];
  } else if (lang === LANG.CN) {
    return Array.isArray(object)
      ? object[attributeName + "Cn"] ||
          object[attributeName + "En"] ||
          object[attributeName]
      : object[attributeName + "Cn"] ||
          object[attributeName + "En"] ||
          object[attributeName];
  } else {
    return Array.isArray(object)
      ? object[attributeName]
      : object[attributeName];
  }
}

export function getAppVersion() {
  if (process.env.VUE_APP_VERSION) {
    return `ver. ${process.env.VUE_APP_VERSION}`;
  }
  return "ver. development";
}

export function logRocket() {
  if (process.env.VUE_APP_LOG_ROCKET_ID) {
    LogRocket.init(process.env.VUE_APP_LOG_ROCKET_ID);
  }
}
